import { cityname } from "./cityname"
import { countyname } from "./countyname"


export const provname = ["北京","天津","河北","山西","内蒙古","辽宁","吉林","黑龙江","上海","江苏","浙江",
"安徽","福建","江西","山东","河南","湖北","湖南","广东","广西","海南","重庆","四川","贵州","云南","西藏",
"陕西","甘肃","青海","宁夏","新疆","台湾","香港","澳门","全国"]


export function citylabel(HeaderID) {
  const importcity = []
  
  HeaderID.map(elem => {
    importcity.push(cityname.filter(el => el.cityid === elem)[0]) 
  })
  const options = []
  provname.filter((item,index) => {
    const children = []
    const els = importcity.filter(el => el.provid === index + 1)
    if (els.length > 1) {
      els.map(ele => {
        children.push({value: ele.cityid, label: ele.CityName})
      })
      options.push({value: index + 1, label: item, children: children})
    } else if (els.length === 1){
      options.push({value: els[0].cityid, label: els[0].CityName})
    }
  })
  options.unshift({value: '全选', label: '全选'})
  return options
}

export function countylabel(HeaderID) {
  const importcounty = []
  HeaderID.map(elem => {
    importcounty.push(countyname.filter(el => el.countyid === elem)[0]) 
  })
  const options = []
  provname.filter((item,index) => {
    const children = []
    const els = importcounty.filter(el => el.provid === index + 1)
    if (els.length > 1) {
      const cityids = els.reduce((acc,obj) => {
        const exitobj = acc.find(item => item.CityCode === obj.CityCode)
        if (!exitobj) {
          acc.push(obj)
        }
        return acc
      },[])

      if (cityids.length > 1) {
        cityids.forEach(ites => {
          const children2 = []
          els.forEach(items => {
            if (items.CityCode === ites.CityCode) {
              children2.push({value: items.countyid, label: items.CountyName})
            } 
          })
          children.push({value: ites.CityCode, label: ites.CityName, children: children2})
        })
      } else if (cityids.length === 1) {
        els.forEach(ite => {
          if (ite.citycode === cityids[0].citycode) {
            children.push({value: ite.countyid, label: ite.CountyName})
          }
        })
      }
      options.push({value: index + 1, label: item, children: children})
    } else if (els.length === 1 ){
      options.push({value: els[0].countyid, label: els[0].CountyName})
    }
  })
  options.unshift({value: '全选', label: '全选'})
  return options
}


// WEBPACK FOOTER //
// ./src/tableworks/admin.js